import { isNonNullable } from '@ori/ts-utils';
import { mapShadeWithPrice } from './mapShadeWithPrice';
const mapSearchPreviewShades = shades => shades?.filter(isNonNullable).map(mapShadeWithPrice) ?? [];
export const mapProductShadesQuery = query => {
  const {
    concept,
    pdpUrl
  } = query.product ?? {};
  return {
    goToUrl: pdpUrl?.relativeUrl ?? '',
    productName: concept?.name ?? '',
    products: mapSearchPreviewShades(query.product?.concept?.products)
  };
};
//# sourceMappingURL=mapProductShadesQuery.js.map